import { useId, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import type { FaqItem } from '../../data/faq';
import { ease } from '../../core/format/motion';

/** Veelgestelde vragen als accordeon; de eerste staat open. Zonder vragen niets. */
export function Faq({
  items,
  title
}: {
  items: FaqItem[];
  title: string;
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const reduce = useReducedMotion();
  const baseId = useId();
  if (items.length === 0) return null;
  return <div className="grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-8650" data-mp="nistozbj9jxe">
      <div className="lg:col-span-4" data-id="element-8651" data-mp="niap9fepvzee">
        <h2 className="type-sub text-ink" data-id="element-8652" data-mp="ijpzk9x3cy47">{title}</h2>
      </div>
      <ul className="border-t border-line lg:col-span-8" data-id="element-8653" data-mp="ik9a35kewk87">
        {items.map((item, i) => {
        const isOpen = openIndex === i;
        const answerId = `${baseId}-${i}`;
        return <li key={item.question} className="border-b border-line" data-id="element-8654" data-mp="2kcxcxdt595ng" data-mpi={i}>
              <h3 data-id="element-8655" data-mp="p5n0hllj986d">
                <button type="button" aria-expanded={isOpen} aria-controls={answerId} onClick={() => setOpenIndex(isOpen ? null : i)} className="group flex w-full items-center justify-between gap-6 py-5 text-left" data-id="element-8656" data-mp="p66jz6qu04mi">
                  <span className="type-name font-light text-ink transition-colors duration-150 ease-soft group-hover:text-clay" data-id="element-8657" data-mp="12y33wnicj87t">{item.question}</span>
                  <span className="shrink-0 text-muted transition-colors duration-150 ease-soft group-hover:text-ink" aria-hidden="true" data-id="element-8658" data-mp="1ct4vrr40aoe3">
                    {isOpen ? <MinusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-8659" data-mp="1gtyjokhg836z" /> : <PlusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-8660" data-mp="1lttc4sgvh0u5" />}
                  </span>
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-8661" data-mp="3ip8xz3g6zo9q">
                {isOpen && <motion.div id={answerId} initial={reduce ? {
              opacity: 0
            } : {
              height: 0,
              opacity: 0
            }} animate={reduce ? {
              opacity: 1
            } : {
              height: 'auto',
              opacity: 1
            }} exit={reduce ? {
              opacity: 0
            } : {
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease
            }} className="overflow-hidden" data-id="element-8662" data-mp="3nmr7ow21a7is">
                    <p className="max-w-2xl pb-6 text-[17px] leading-relaxed text-muted" data-id="element-8663" data-mp="1dqmuzpvqxmmy">{item.answer}</p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </div>;
}